import { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Context } from '../../../Context';
import Select from 'react-select';
import bim_styles from '../../../styles/bim.module.scss';
import apart_styles from '../../../styles/aprt.module.scss';

function AddSupplementalAreas() {
	const { activeApartmentData, projectSetup, projectStyle } =
		useContext(Context);
	const { t } = useTranslation();

	const currentUuid = activeApartmentData ? activeApartmentData.uuid : null;

	const availableSupplements = [
		//get from data
		{
			type: 'parking',
			name: 'idParkingSpaceOutdoor',
			priceRange: [30000, 35000],
			name_original: 'ZMP01',
		},
	];

	const getSelectStyles = () => ({
		control: (baseStyles, state) => ({
			...baseStyles,
			minHeight: '2.5rem',
			minWidth: '12rem',
			// backgroundColor: 'var(--color-offwhite)',
			borderColor: state.isFocused
				? 'var(--color-secondary)'
				: 'hsl(0, 0%, 80%)',
			borderRadius: '0px',
			boxShadow: state.isFocused ? '0 0 0 1px var(--color-secondary)' : 'none',
			'&:hover': {
				borderColor: 'var(--color-secondary)',
			},
		}),
		option: (baseStyles, state) => ({
			...baseStyles,
			fontSize: '0.9rem',
			padding: '0.4rem 0.75rem',
			backgroundColor: state.isSelected
				? 'var(--color-secondary)'
				: state.isFocused
				? '#' + projectStyle.__color_secondary + '60'
				: 'transparent',
		}),
	});

	// Opcje dla Select
	// TODO: think how to implement this:
	//  const parkingOptions = availableSupplements.filter(sup => sup.type === 'parking').map((sup) => ({
	//    value: sup.name,
	//    label: sup.name_original,
	//  }));
	//  const storageOptions = availableSupplements.filter(sup => sup.type === 'storage').map((sup) => ({
	//    value: sup.name,
	//    label: sup.name_original,
	//  }));
	const parkingSpacesOptions = [
		{ value: 0, label: 'Bez miejsca' },
		{ value: 1, label: '1 - miejsce' },
		{ value: 2, label: '2 - miejsca' },
	];
	const storageUnitOptions = [
		{ value: 0, label: 'Bez komórki' },
		{ value: 1, label: '1 - komórka' },
		{ value: 2, label: '2 - komórki' },
	];
	// Wybrane wartości jako obiekty
	//  const selectedParking = sortKeyOptions.find(opt => opt.value === sortingConfig.key) || sortKeyOptions[0];
	//  const selectedSortDirection = sortDirectionOptions.find(opt => opt.value === sortingConfig.direction) || sortDirectionOptions[0];
	const [selectedParkingSpaces, setSelectedParkingSpaces] = useState([]);
	const [selectedStorageUnits, setSelectedStorageUnits] = useState([]);

	useEffect(() => {
		const storedSupplementsChoices =
			JSON.parse(localStorage.getItem('selectedSupplements')) || {};
		const storageUpdate = {
			...storedSupplementsChoices,
			[currentUuid]: {
				parkingSpaces: selectedParkingSpaces,
				storageUnits: selectedStorageUnits,
			},
		};
		localStorage.setItem('selectedSupplements', JSON.stringify(storageUpdate));

	}, [selectedParkingSpaces, selectedStorageUnits,]);
	useEffect(() => {
		const storedSupplementsChoices =
			JSON.parse(localStorage.getItem('selectedSupplements')) || {};

		const currentSupp = storedSupplementsChoices[currentUuid];
		if (currentSupp) {
			setSelectedParkingSpaces(currentSupp.parkingSpaces || []);
			setSelectedStorageUnits(currentSupp.storageUnits || []);
		} else {
			setSelectedParkingSpaces([]);
			setSelectedStorageUnits([]);
		}
	}, [currentUuid]);

	return (
		<div style={{ marginTop: '0.5rem' }}>
			<span //h4?
				style={{
					display: 'inline-block',
					fontSize: ' 1.2rem',
					fontWeight: '600',
					color: 'var(--color-headings)',
				}}
			>
				Dodaj do zapytania:
			</span>
			<div
				style={{
					marginTop: '0.5rem',
					display: 'grid',
					columnGap: '0.5rem',
					gridTemplateColumns: 'repeat(2, 1fr)',
				}}
			>
				<Select
					id="supplements-parking"
					styles={getSelectStyles()}
					value={parkingSpacesOptions.find((opt) =>
						selectedParkingSpaces.includes(opt.value)
					)}
					options={parkingSpacesOptions}
					onChange={(option) => {
						const selected = option ? [option.value] : [];
						setSelectedParkingSpaces(selected);
					}}
					placeholder={`m. postojowe`}
				/>

				<Select
					id="supplements-storage"
					value={storageUnitOptions.find((opt) =>
						selectedStorageUnits.includes(opt.value)
					)}
					options={storageUnitOptions}
					onChange={(option) => {
						const selected = option ? [option.value] : [];
						setSelectedStorageUnits(selected);
					}}
					placeholder={`komórki lok.`}
					styles={getSelectStyles()}
				/>
			</div>
		</div>
	);
}

export default AddSupplementalAreas;
